import Logo2020 from '../../src/legacy/Logo2020';
export default Logo2020;
